import React from 'react'

interface Props {
    label: string
    checked: boolean
    onChange: (checked: boolean) => void
    disabled: boolean
}

const Checkbox: React.FC<Props> = ({ label, checked, onChange, disabled }) => {
    return (
        <label className="flex flex-row items-center cursor-pointer">
            <input
                type="checkbox"
                className="peer appearance-none"
                checked={checked}
                onChange={(event) => {
                    onChange(event.target.checked)
                }}
                disabled={disabled}
            />
            <div
                className="
        shrink-0

        relative
        w-11
        h-6
        bg-[#d8dadc]
        dark:border-gray-600
        dark:bg-[#656365]
        rounded-full
        
        peer
        peer-focus:ring-1
        peer-focus:ring-[#181818]
        dark:peer-focus:ring-[#ffffff]
        peer-checked:after:translate-x-full
        peer-checked:after:border-[#FFFFFF]
        peer-checked:bg-[#83d2b7]
        dark:peer-checked:bg-[#187a33]
        
        after:content-['']
        after:absolute
        after:top-0.5
        after:start-[2px]
        after:bg-[#FFFFFF]
        after:rounded-full
        after:h-5
        after:w-5
        after:transition-all

        peer-disabled:bg-[#d4d6d8]
        dark:peer-disabled:bg-[#1f1e1f]
        peer-disabled:peer-checked:bg-[#d4d6d8]
        dark:peer-disabled:peer-checked:bg-[#1f1e1f]

        peer-disabled:after:bg-[#c8c8c8]
        dark:peer-disabled:after:bg-[#656365]
        peer-disabled:peer-checked:after:bg-[#83d2b7]
        dark:peer-disabled:peer-checked:after:bg-[#187a33]
        "
            ></div>
            <span className="form-label h-full flex ml-2 items-center justify-center">
                {label}
            </span>
        </label>
    )
}

export default Checkbox
